export default __webpack_public_path__ + "static/media/medium_dot.e2afe276.svg";